/**
 * Canonical tracking helper: pushes to PostHog (product analytics) and
 * window.dataLayer (GTM / marketing tags). Use this for conversion events
 * so GTM can forward to Meta Pixel, GA4, etc.
 * Rule: do not use window.dataLayer.push(...) anywhere else in the codebase.
 */

type Props = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: unknown[];
    posthog?: { capture: (event: string, props?: Props) => void };
  }
}

export function track(event: string, props: Props = {}): void {
  // PostHog (product analytics)
  try {
    window.posthog?.capture(event, props);
  } catch {
    // swallow errors
  }

  // GTM dataLayer (marketing tags)
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...props });
  } catch {
    // swallow errors
  }
}
